import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// 🔐 Replace these with your own Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyANqfnA2-FikrdFjREASecw29WWw8hsVWw",
  authDomain: "mindful-self-discipline.firebaseapp.com",
  projectId: "mindful-self-discipline",
};

// 🔥 Initialize Firebase
const app = initializeApp(firebaseConfig);

// 📦 Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
